import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { bootstrapFontScale } from './hooks/useFontScale.js';
import './index.css';

bootstrapFontScale();

const root = document.getElementById('root');
createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);

requestAnimationFrame(() => {
  const boot = document.getElementById('boot-loader');
  if (!boot) return;
  boot.style.opacity = '0';
  boot.style.pointerEvents = 'none';
  window.setTimeout(() => boot.remove(), 280);
});
